import type { Logger } from '@vp/ubik-logging'

import { postDocument } from '../../../clients/UdsClient'
import type { PageMode } from '../../../types/QuantitySelectionData'
import type { RelatedProduct } from '../../../types/RelatedProduct'
import type { WorkId } from '../../../types/WorkId'
import { createAndSaveWork } from '../../../utils/WorkHelpers'

export const createWorkFromRelatedProduct = async (
  cartTenant: string,
  mpvTenant: string,
  culture: string,
  ownerId: string,
  isCareAgent: boolean,
  editUrlPath: string,
  relatedProduct: RelatedProduct,
  primaryProjectPageMode: PageMode,
  authorizationHeader: string,
  logger: Logger,
): Promise<WorkId> => {
  if (relatedProduct.workId) {
    return relatedProduct.workId // this related product already has an associated work entity
  }

  // we need to store the transformed document to UDS.
  const postDocResponse = await postDocument(relatedProduct.cimDoc, authorizationHeader, logger)

  // logic assumes related products use the same page mode as the primary project
  const isSizedGood = primaryProjectPageMode === 'Sized Good'

  return await createAndSaveWork(
    cartTenant,
    relatedProduct.productName,
    editUrlPath,
    postDocResponse,
    ownerId,
    relatedProduct.productKey,
    relatedProduct.productVersion,
    mpvTenant,
    culture,
    relatedProduct.mpvId,
    relatedProduct.selectedOptions,
    relatedProduct.minimumOrderQuantity,
    isSizedGood,
    isCareAgent,
    authorizationHeader,
    logger,
  )
}
